import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "components/CustomButtons/Button.jsx";
import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";
import cmplogo from "assets/img/datadelivers_logo.png";
import "assets/scss/styles.css";

function Footer({ ...props }) {
  const { classes, fluid, white } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white
    });
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white
  });

  let hasFooter = true
  try {
    if (window.location.href.includes('dashboard') || window.location.href.includes('insights')) {
      hasFooter = false
    }
  }
  catch (e) {
  }

  return (
    <footer>
      {hasFooter && (
        <div className={container}>
          <div className={classes.center}>
            &copy; {1900 + new Date().getYear()} <a />
            <a href="https://datadelivers.com" target="_blank" className={anchor}>
              <img style={{ height: "15px", paddingRight: "5px" }} className="logoHeight" src={cmplogo} />
            </a>
            <a style={{ color: "#093e52" }} href="https://datadelivers.com/privacy-point-of-view-for-datadelivers-client-data/" target="_blank" >Privacy Policy</a> |{" "}
            <a style={{ color: "#093e52" }} href="https://www.datadelivers.com/terms-of-service/" target="_blank" >Terms of Service</a>
          </div>

          <div className={classes.right}>
            <List className={classes.list}>
              <ListItem className={classes.inlineBlock}>
                <Button
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/company/datadelivers-llc/",
                      "_blank"
                    )
                  }
                  justIcon
                  color="linkedin"
                  simple
                >
                  <i
                    className={
                      classes.socialButtonsIcons +
                      " " +
                      classes.marginRight +
                      " fab fa-linkedin"
                    }
                  />
                </Button>
              </ListItem>
              <ListItem className={classes.inlineBlock}>
                <Button
                  onClick={() =>
                    window.open("https://twitter.com/DatadeliversL", "_blank")
                  }
                  justIcon
                  color="twitter"
                  simple
                >
                  <i
                    className={
                      classes.socialButtonsIcons +
                      " " +
                      classes.marginRight +
                      " fab fa-twitter"
                    }
                  />
                </Button>
              </ListItem>
              <ListItem className={classes.inlineBlock}>
                <Button
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/DataDelivers-LLC-102552678527463",
                      "_blank"
                    )
                  }
                  justIcon
                  color="facebook"
                  simple
                >
                  <i
                    className={
                      classes.socialButtonsIcons +
                      " " +
                      classes.marginRight +
                      " fab fa-facebook-square"
                    }
                  />
                </Button>
              </ListItem>
              <ListItem className={classes.inlineBlock}>v3.5.34</ListItem>
            </List>
          </div>
        </div>
      )}
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx